module.exports = __webpack_public_path__ + "img/oslogo.1cc2188d.png";